import React from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
export function HeroSection() {
  return <section className="relative pt-20 pb-16 md:pt-32 md:pb-24 overflow-hidden" data-id="element-81">
      <div className="max-w-6xl mx-auto px-6 lg:px-8" data-id="element-82">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-83">
          <div className="order-2 lg:order-1" data-id="element-84">
            <FadeIn delay={0.1} data-id="element-85">
              <span className="inline-block py-1 px-3 rounded-full bg-teal-100 text-teal-800 text-sm font-semibold tracking-wide uppercase mb-6" data-id="element-86">
                Para Mujeres 35+
              </span>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-87">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-teal-900 leading-tight mb-6" data-id="element-88">
                Duerma Sin Dolor: El Protocolo de 8 Minutos para Liberar el
                Nervio Ciático
              </h1>
            </FadeIn>

            <FadeIn delay={0.3} data-id="element-89">
              <p className="text-lg md:text-xl text-gray-700 mb-8 leading-relaxed" data-id="element-90">
                La guía definitiva para mujeres que necesitan detener el
                "chispazo" en la pierna y recuperar su movilidad sin fármacos ni
                cirugías.
              </p>
            </FadeIn>

            <FadeIn delay={0.4} data-id="element-91">
              <Button onClick={() => document.getElementById('offer')?.scrollIntoView({
              behavior: 'smooth'
            })} data-id="element-92">
                DESCARGAR MI GUÍA AHORA
              </Button>
              <p className="mt-4 text-sm text-gray-500 flex items-center gap-2" data-id="element-93">
                <span className="w-2 h-2 rounded-full bg-green-500 inline-block" data-id="element-94"></span>
                Acceso inmediato y privado a tu correo electrónico
              </p>
            </FadeIn>
          </div>

          <div className="order-1 lg:order-2 relative" data-id="element-95">
            <FadeIn delay={0.3} direction="left" data-id="element-96">
              <div className="relative rounded-2xl overflow-hidden shadow-2xl" data-id="element-97">
                <div className="absolute inset-0 bg-teal-900/10 mix-blend-multiply" data-id="element-98"></div>
                <img src="https://cdn.magicpatterns.com/uploads/gvs8Y6MsgK19DdKBAUVeje/PORTADA.png" alt="Alivio Ciático: El Método de 8 Minutos - Guía Digital" className="w-full h-auto object-cover" data-id="element-99" />
              </div>

              {/* Decorative elements */}
              <div className="absolute -bottom-6 -left-6 w-24 h-24 bg-coral-100 rounded-full -z-10 blur-2xl opacity-70" data-id="element-100"></div>
              <div className="absolute -top-6 -right-6 w-32 h-32 bg-teal-100 rounded-full -z-10 blur-2xl opacity-70" data-id="element-101"></div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}